export type DevRuntimeFlags = {
  skipPersonaPassword?: boolean;
};

export const DEV_RUNTIME_FLAGS_STORAGE_KEY = 'triedge-dev-runtime-flags';
const DEV_RUNTIME_FLAG_DEFAULTS: DevRuntimeFlags = {
  skipPersonaPassword: true,
};

declare global {
  interface Window {
    __TRIEDGE_DEV_FLAGS__?: DevRuntimeFlags;
  }
}

const parseFlags = (raw: string | null): DevRuntimeFlags => {
  if (!raw) return {};
  try {
    const parsed = JSON.parse(raw) as DevRuntimeFlags;
    if (!parsed || typeof parsed !== 'object') return {};
    return parsed;
  } catch {
    return {};
  }
};

const readFlagsFromStorage = (): DevRuntimeFlags => {
  try {
    const raw = window.localStorage.getItem(DEV_RUNTIME_FLAGS_STORAGE_KEY);
    return parseFlags(raw);
  } catch {
    return {};
  }
};

const readFlagsFromWindow = (): DevRuntimeFlags => {
  if (typeof window === 'undefined') return {};
  const fromWindow = window.__TRIEDGE_DEV_FLAGS__;
  if (!fromWindow || typeof fromWindow !== 'object') return {};
  return fromWindow;
};

export const getDevRuntimeFlags = (): DevRuntimeFlags => {
  if (!import.meta.env.DEV || typeof window === 'undefined') {
    return {};
  }
  return {
    ...DEV_RUNTIME_FLAG_DEFAULTS,
    ...readFlagsFromStorage(),
    ...readFlagsFromWindow(),
  };
};

export const isDevRuntimeBuild = (): boolean => import.meta.env.DEV;

export const isDevRuntimeFlagEnabled = (key: keyof DevRuntimeFlags): boolean =>
  Boolean(getDevRuntimeFlags()[key]);
